// extracted by mini-css-extract-plugin
export default {"overlay":"Ex-z","bodyOpen":"Fx-z","content":"Gx-z","header":"Hx-z","close":"Ix-z","closeNoHeading":"Jx-z"};